import React, { Component } from "react";
import { service, actions } from "./log-data";
import { injectIntl, intlShape } from "@ai360/core/intl";
import { withCrud } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { messages } from "../i18n-messages";

interface ISurfaceDefaultsLogProps {
    records: [];
    intl: intlShape;
}

export class SurfaceDefaultsLog_ extends Component<ISurfaceDefaultsLogProps> {
    componentDidUpdate() {
        if (this.props.records) {
            for (const item of this.props.records) {
                FormattingHelpers.formatLogDetailText(item);
            }
        }
    }
    render() {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
            />
        );
    }
}
export const SurfaceDefaultsLog = injectIntl(withCrud(SurfaceDefaultsLog_, service, actions));
